<template>
  <rpm-modal persist :open="open" class="flex flex-col gap-y-8" @close="$emit('close')">
    <div class="w-full border-b pb-3">
      <h2 class="text-xl font-bold text-left">
        Excluir Todos os Anexos (Questionários)
      </h2>
    </div>

    <div class="text-center flex flex-col gap-1">
      <h3 class="text-lg font-semibold">
        Procedimento Origem:
        <span class="text-red-600">
          {{ sourceProcedure?.title || 'Não informado' }}
        </span>
      </h3>

      <p class="text-sm text-default/80 dark:text-white/80">
        Você tem certeza que deseja excluir **TODOS** os anexos (questionários)
        associados a este Procedimento Origem
        <strong>ID {{ sourceProcedure?.id }}</strong>?
      </p>
    </div>

    <section class="flex flex-row justify-center gap-6">
      <rpm-button
          @click="$emit('close')"
          color="gray"
          label="Não"
      ></rpm-button>

      <rpm-button
          label="Sim, excluir tudo"
          color="red"
          @click="deleteAllQuestionnaires"
      ></rpm-button>
    </section>
  </rpm-modal>
</template>

<script>
import RpmModal from "#components/RpmModal.vue";
import sourceProcedureRepository from "#repositories/sourceProcedureRepository";

export default {
  name: 'DeleteAllQuestionnairesModal',
  components: {
    RpmModal
  },
  props: {
    sourceProcedure: {
      type: Object
    },
    open: {
      type: Boolean
    }
  },
  methods: {
    deleteAllQuestionnaires() {
      if (!this.sourceProcedure || !this.sourceProcedure.id) {
        this.$notify('Erro: Procedimento Origem não especificado para exclusão de questionários.', 'error');
        return;
      }
      sourceProcedureRepository.deleteAllQuestionnaires(this.sourceProcedure.id)
          .then(() => {
            this.$notify('Todos os anexos (questionários) excluídos com sucesso!', 'success');
            this.$emit('deleted');
            this.$emit('close');
          })
          .catch(error => {
            console.error('Erro ao excluir todos os questionários:', error);
            this.$notify('Erro ao excluir anexos. Tente novamente.', 'error');
          });
    }
  }
}
</script>